import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Money'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2514 0 48 10.7486 48 24C48 37.2514 37.2514 48 24 48C10.7486 48 0 37.2514 0 24C0 10.7486 10.7486 0 24 0Z"
          fill="#FFD6B0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 35.1562C26.1939 35.1562 29.5938 31.7564 29.5938 27.5625C29.5938 23.3686 26.1939 19.9688 22 19.9688C17.8061 19.9688 14.4062 23.3686 14.4062 27.5625C14.4062 31.7564 17.8061 35.1562 22 35.1562Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0824 24.4282L9.34375 14.9062L12.7188 9.84375L18.9985 20.5864"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3125 24.1875H21.1562C21.6222 24.1875 22 24.5653 22 25.0312V30.9375"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.3125 30.9375H23.6875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.9181 24.4282L34.6567 14.9062L31.2817 9.84375L25.002 20.5864"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.2812 9.84375H12.7188"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 40.5902V38.4302"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.1805 36.8099L29.5605 35.1899"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8203 36.8099L14.4403 35.1899"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.8008 28.71H34.9608"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.03906 28.71H11.1991"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
